import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-issue-seller-address-labels',
  templateUrl: './issue-seller-address-labels.component.html',
  styleUrl: './issue-seller-address-labels.component.scss'
})
export class IssueSellerAddressLabelsComponent implements OnInit {
  labelsData = [];
  tempdata = [];
  data1 = [];
  today = new Date();
  repNames = '';
  deliveryMode = '';
  firstRepName = '';
  lastRepName = '';
  district = '';
  state = '';
  taluka = '';
  iscustomer: any;

  constructor(
    private dialogref: MatDialogRef<IssueSellerAddressLabelsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.labelsData = this.data['addresslabels'];
    this.repNames = this.data['rep_names'];
    this.deliveryMode = this.data['delivery_mode'];

    if (Array.isArray(this.repNames) && this.repNames.length > 0) {
      this.firstRepName =
        this.repNames[0] == 'all' ? this.repNames[1] : this.repNames[0];
      this.lastRepName = this.repNames[this.repNames.length - 1];
    }

    this.district = this.data['district_name'];
    this.state = this.data['state_name'];
    this.taluka = this.data['taluka_name'];
    this.iscustomer = this.data['iscustomer'];

    this.tempdata = this.uniqueid(this.labelsData, (a) => a['district']);
    this.sortDataDistrictwise();
  }

  sortDataDistrictwise() {
    this.labelsData.sort((a, b) => Number(a.pincode) - Number(b.pincode));

    for (let index = 0; index < Object.keys(this.tempdata).length; index++) {
      let data = this.labelsData.filter(
        (a) => a['district'] == this.tempdata[index]['district']
      );

      this.data1.push(data);
    }

    let flatData = [];
    this.data1.forEach(element => {
      element.forEach(data2 => {
        flatData.push(data2);
      });
    });

    this.data1 = flatData;

    if (this.data1.length <= 4) {
      const requiredLength = 5;
      const numberOfItemsToAdd = requiredLength - this.data1.length;

      for (let i = 0; i < numberOfItemsToAdd; i++) {
        this.data1.push({
          month: '',
          subno: '',
          year: '',
          title: '',
          name: '',
          address: '',
          taluka: '',
          district: '',
          pincode: '',
          state: ''
        });
      }
    }
  }

  uniqueid(data, key) {
    return [...new Map(data.map((x) => [key(x), x])).values()];
  }

  getPageNumber(index: number): number {
    return Math.floor(index / 28) + 1;
  }

  print() {
    document.title = 'Labels';
    window.print();
  }
}
